"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@veeam/core");
var formatValue_1 = require("../DatetimeInput/formatValue");
var helpers_1 = require("./helpers");
var DEFAULT_TEXTS = {
    am: 'AM',
    pm: 'PM',
    allTime: 'All Time'
};
var DatePeriodInteractor = /** @class */ (function (_super) {
    __extends(DatePeriodInteractor, _super);
    function DatePeriodInteractor(valueModel, listener, config) {
        var _this = _super.call(this) || this;
        _this.valueModel = valueModel;
        _this.listener = listener;
        _this.config = config;
        _this.textValueModel = new core_1.Model('');
        _this.didDone = function (nextValue) {
            var _a, _b, _c;
            _this.valueModel.setValue(nextValue);
            (_a = _this.presenter) === null || _a === void 0 ? void 0 : _a.hideMenu();
            (_c = (_b = _this.listener) === null || _b === void 0 ? void 0 : _b.onChange) === null || _c === void 0 ? void 0 : _c.call(_b, nextValue);
        };
        _this.updateTextValue = function () {
            var value = _this.valueModel.getValue();
            var texts = _this.config.texts;
            if (!value.length) {
                _this.textValueModel.setValue((texts === null || texts === void 0 ? void 0 : texts.allTimeValueText) || DEFAULT_TEXTS.allTime);
                return;
            }
            if (value.length === 1 || helpers_1.isOneDay(value[0], value[1])) {
                _this.textValueModel.setValue(formatValue_1.formatValue(value[0], false, false, DEFAULT_TEXTS));
                return;
            }
            _this.textValueModel.setValue(formatValue_1.formatValue(value[0], false, false, DEFAULT_TEXTS) + " - " + formatValue_1.formatValue(value[1], false, false, DEFAULT_TEXTS));
        };
        _this.updateTextValue();
        _this.valueModel.asObservable().subscribe(function () {
            _this.updateTextValue();
        });
        return _this;
    }
    return DatePeriodInteractor;
}(core_1.Interactor));
exports.DatePeriodInteractor = DatePeriodInteractor;
//# sourceMappingURL=DatePeriodInteractor.js.map